import styled from '@emotion/styled'

import { Spacing } from '../../enums/spacing'

export const FilesPaginationComponent = styled.nav`
  display: inline-flex;
  align-items: center;
  gap: ${Spacing.S8};
`
